/**
 * Returns a sorted array of unique items from the input array, using a key selector for uniqueness.
 * The result order is deterministic based on the key. Look into Intl.Collator, it is awesome!
 *
 * @param items - Array of items to deduplicate
 * @param keySelector - Function to extract a unique key from each item
 * @returns Sorted array of unique items
 */
export function createDeterministicUniqueSet(items, keySelector) {
    // Deduplicate by key (keeps first occurrence)
    const byKey = new Map();
    for (const item of items) {
        const key = keySelector(item);
        if (!byKey.has(key))
            byKey.set(key, item);
    }
    // Use Intl.Collator for consistent, performant string compare
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "base",
    });
    const keys = Array.from(byKey.keys());
    keys.sort(collator.compare);
    return keys.map((k) => byKey.get(k));
}
export const naturalSortListByAttribute = (list, key) => {
    const copy = [...list];
    return copy.sort((a, b) => {
        if (typeof a[key] !== "string") {
            return 0;
        }
        const aString = a[key];
        const bString = b[key];
        if (!aString || !bString) {
            return 0;
        }
        return aString.localeCompare(bString, undefined, { numeric: true });
    });
};
/**
 * OPP unit codes are 3–4 chars (004, 095, 0077). Legion Countries using
 * SuccessFactors prepends "00", but OPP doesn't as OPP org data for Legion countries
 * has different source.
 */
export const normalizeUnitCode = (unitCode, isLegionCountry) => isLegionCountry && unitCode.length > 4
    ? unitCode.replace(/^00/, "")
    : unitCode;
//# sourceMappingURL=utils.mjs.map